import React from 'react';

export const ShowReconciledCart = ({ cart }) => {
    const deprecated = cart?.deprecatedProducts ?? [];
    const hasDeprecated = deprecated.length > 0;

    const headerBg = hasDeprecated ? 'bg-danger text-white' : 'bg-success text-white';
    const badgeBg = hasDeprecated ? 'bg-light text-danger' : 'bg-light text-success';
    const statusText = hasDeprecated
        ? 'Productos desactualizados - revise su pedido'
        : 'No hay productos desactualizados';

    return (
        <section className="container my-4">
            <div className={`p-3 rounded shadow-sm ${headerBg} d-flex justify-content-between align-items-center`}>
                <h2 className="h6 mb-0">{statusText}</h2>
                <span className={`badge ${badgeBg}`}>{deprecated.length}</span>
            </div>
        </section>
    );
};
